import ResourcesService from '@/services/resources.service';
import SkeletonsTypeService from '@/services/skeletonsType.service';
import PosesService from '@/services/poses.service';
import AnimationsTypeService from '@/services/animationsType.service';
import axios from 'axios';

import {
  FETCH_RESOURCES,
  CREATE_RESOURCE,
  FETCH_ALL_RESOURCES,
  DELETE_RESOURCE,
  FIND_RESOURCE,
  UPDATE_RESOURCE,
  CLEAR_RESOURCE,
  FETCH_SKELETONS_TYPES,
  FETCH_POSES_TYPES,
  FETCH_ANIMATIONS_TYPES,
  CREATE_RESOURCE_TYPE,
  UPDATE_RESOURCE_TYPE,
  DELETE_RESOURCE_TYPE,
} from './resources.actions.types';
import {
  SET_RESOURCES,
  SET_RESOURCES_DICT,
  SET_RESOURCE,
  SET_ERROR,
  SET_SKELETONS_TYPES,
  SET_ANIMATIONS_TYPES,
  SET_ANIMATIONS,
  SET_POSES_TYPES,
  SET_RESOURCE_TYPE,
  REMOVE_RESOURCE_TYPE,
} from './resources.mutations.types';

import { CREATE_SCENE_DICT, UPDATE_SCENE_DICT } from '../relations/relations.actions.types';
const state = {
  error: null,
  resources: [],
  resource: {
    access: { mode: 'public', clientIds: [] },
  },
  resourcesDict: {},
  animations: [],
  skeletonsTypes: [],
  animationsTypes: [],
  posesTypes: [],
};

const actions = {
  async [FETCH_RESOURCES]({ commit, dispatch, rootState }, params) {
    try {
      const { sort = 'name', page = 1, rowsPerPage = 10 } = rootState.ui.pagination;
      const { filters, search } = rootState.ui;
      let $filter = '';
      const languages = ['es', 'en', 'fr', 'de'];
      if (filters.translation !== 'all') {
        // Si es 'translated' miramos si name está relleno
        if (filters.translation === 'translated') {
          $filter = $filter.concat('translations ne null');
          if (filters.language === 'all') {
            languages.forEach((lang) => {
              $filter = $filter.concat(` and translations/${lang}/name ne null`);
              $filter = $filter.concat(` and translations/${lang}/tags gt 0`);
            });
          } else {
            const lang = filters.language;
            $filter = $filter.concat(` and translations/${lang}/name ne null`);
            $filter = $filter.concat(` and translations/${lang}/tags gt 0`);
          }
        } else if (filters.translation === 'non-translated') {
          $filter = $filter.concat('(translations eq null');
          if (filters.language === 'all') {
            languages.forEach((lang) => {
              $filter = $filter.concat(` or translations/${lang}/name eq null`);
              $filter = $filter.concat(` or translations/${lang}/tags eq null`);
            });
          } else {
            const lang = filters.language;
            $filter = $filter.concat(` or translations/${lang}/name eq null`);
            $filter = $filter.concat(` or translations/${lang}/tags eq null`);
          }
          $filter = $filter.concat(')');
        }
      }
      if (filters.access !== 'all') {
        $filter = $filter
          ? $filter.concat(` and access/mode eq '${filters.access}'`)
          : $filter.concat(`access/mode eq '${filters.access}'`);
      }
      if (filters.resourceType !== 'all') {
        $filter = $filter
          ? $filter.concat(` and type eq '${filters.resourceType}'`)
          : $filter.concat(`type eq '${filters.resourceType}'`);
      }
      const resources = await ResourcesService.fetchResources({
        $filter,
        page,
        search,
        limit: rowsPerPage,
        sort,
        ...params,
      });

      commit(SET_RESOURCES, resources.docs);
      dispatch(
        'ui/setPaginationData',
        {
          ...rootState.ui.pagination,
          totalItems: resources ? resources.total : 0,
        },
        { root: true }
      );
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
  async [FETCH_ALL_RESOURCES]({ commit, dispatch }) {
    try {
      console.log('FETCH_ALL_RESOURCES - starting');
      // Always reload all resources to ensure up-to-date data
      const response = await ResourcesService.fetchResources({ status: 'PUBLISHED' });

      if (!response || !response.pages) {
        throw new Error('Failed to fetch resources: empty response');
      }

      const { pages } = response;
      console.log('Total pages to fetch:', pages);
      let dict = {};
      const animations = [];

      for (let i = 0; i < pages; i++) {
        const response = await ResourcesService.fetchResources({
          page: i + 1,
          status: 'PUBLISHED',
        });

        // Handle case where response might be empty (e.g., 304 Not Modified)
        if (!response || !response.docs) {
          console.warn(`Page ${i + 1}: No docs in response, skipping`);
          continue;
        }

        const { docs } = response;
        console.log(`Page ${i + 1}: fetched ${docs.length} resources`);

        // Filter out invalid resources
        const validDocs = docs.filter(r => r && r.id);
        console.log(`Page ${i + 1}: valid resources = ${validDocs.length}`);

        const tempDict = validDocs.reduce((acc, r) => ({
          ...acc,
          [r.id]: { ...r },
        }), {});
        animations.push(...Object.values(tempDict).filter((r) => r.type === 'animation'));
        dict = { ...dict, ...tempDict };
      }

      console.log('Final counts:', {
        totalResources: Object.keys(dict).length,
        totalAnimations: animations.length,
      });

      console.log('Committing resources dict...');
      commit(SET_RESOURCES_DICT, dict);
      console.log('Committing animations...');
      commit(SET_ANIMATIONS, animations);

      // Fetch resource types
      console.log('Fetching resource types...');
      await Promise.all([
        dispatch(FETCH_SKELETONS_TYPES),
        dispatch(FETCH_ANIMATIONS_TYPES),
        dispatch(FETCH_POSES_TYPES),
      ]);
      console.log('FETCH_ALL_RESOURCES - completed');
    } catch (error) {
      console.error('FETCH_ALL_RESOURCES - error:', error);
      commit(SET_ERROR, error);
    }
  },
  async [FETCH_POSES_TYPES]({ commit }, params) {
    try {
      const poses = await PosesService.fetchPosesTypes({
        ...params,
      });
      if (poses && poses.docs) {
        commit(SET_POSES_TYPES, poses.docs);
      }
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
  async [FETCH_SKELETONS_TYPES]({ commit }, params) {
    try {
      const skeletonsTypes = await SkeletonsTypeService.fetchSkeletonsTypes({
        page: 1,
        limit: 1000,
        ...params,
      });
      if (skeletonsTypes && skeletonsTypes.docs) {
        commit(SET_SKELETONS_TYPES, skeletonsTypes.docs);
      }
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
  async [FETCH_ANIMATIONS_TYPES]({ commit }, params) {
    try {
      const animationsTypes = await AnimationsTypeService.fetchAnimationsTypes({
        page: 1,
        limit: 1000,
        ...params,
      });
      if (animationsTypes && animationsTypes.docs) {
        commit(SET_ANIMATIONS_TYPES, animationsTypes.docs);
      }
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
  async [FIND_RESOURCE]({ commit }, id) {
    try {
      const data = await ResourcesService.findResource(id);

      commit(SET_RESOURCE, data);
      return data;
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
  async [DELETE_RESOURCE]({ commit }, id) {
    try {
      await ResourcesService.deleteResource(id);

      commit(DELETE_RESOURCE, id);
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
  async [CREATE_RESOURCE_TYPE]({ commit }, { type, resourceType }) {
    try {
      let resource;
      delete resourceType.id;
      switch (type) {
        case 'poses': {
          resource = await PosesService.createPoseType(resourceType);
          break;
        }
        case 'animations': {
          resource = await AnimationsTypeService.createAnimationType(resourceType);
          break;
        }
        case 'skeletons': {
          resource = await SkeletonsTypeService.createSkeletonType(resourceType);
          break;
        }
      }

      commit(SET_RESOURCE_TYPE, { resource, type });
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
  async [UPDATE_RESOURCE_TYPE]({ commit }, { type, resourceType }) {
    if (!resourceType.id) return;
    try {
      let resource;
      switch (type) {
        case 'poses': {
          resource = await PosesService.updatePoseType(resourceType);
          break;
        }
        case 'animations': {
          resource = await AnimationsTypeService.updateAnimationType(resourceType);
          break;
        }
        case 'skeletons': {
          resource = await SkeletonsTypeService.updateSkeletonType(resourceType);
          break;
        }
      }

      commit(SET_RESOURCE_TYPE, { resource, type });
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
  async [DELETE_RESOURCE_TYPE]({ commit }, { type, id }) {
    try {
      switch (type) {
        case 'poses': {
          await PosesService.deletePoseType(id);
          break;
        }
        case 'animations': {
          await AnimationsTypeService.deleteAnimationType(id);
          break;
        }
        case 'skeletons': {
          await SkeletonsTypeService.deleteSkeletonType(id);
          break;
        }
      }

      commit(REMOVE_RESOURCE_TYPE, { type, id });
    } catch (error) {
      commit(SET_ERROR, error);
      throw error; // Re-throw to handle in component
    }
  },
  async [CREATE_RESOURCE]({ commit, dispatch }, resource) {
    try {
      const resourceData = {
        access: resource.access,
        name: resource.name,
        type: resource.type,
        scale: resource.scale || 1,
        status: resource.status,
        translations: resource.translations || null, //JOSE AQUI ESTO BIEN???
        resourceSize: resource.resourceSize || null,
      };
      const files = {
        fileName: (resource.file && resource.file.name) || {}.name,
        fileType: (resource.file && resource.file.type) || '',
      };

      // If is a character or an object we'll include the preview and thumbnail file
      if (resource.type && ['character', 'object', 'scene'].includes(resource.type)) {
        if (resource.previewFile) {
          files.previewFileType = resource.previewFile.type;
        }
        if (resource.thumbnailFile) {
          files.thumbnailFileType = resource.thumbnailFile.type;
        }
      }
      switch (resource.type) {
        case 'character':
          resourceData.skeletonId = resource.skeletonId;
          resourceData.canWalk = resource.canWalk;
          break;
        case 'animation':
          resourceData.skeletonId = resource.skeletonId;
          resourceData.animationId = resource.animationId;
          break;
        case 'pose':
          resourceData.skeletonId = resource.skeletonId;
          resourceData.poseId = resource.poseId;
          break;
        case 'environment':
          resourceData.environmentId = resource.environmentId;
          break;
        case 'scene':
          resourceData.scene360 = resource.scene360;
          resourceData.walkable = resource.walkable;
          break;
      }
      resourceData.version30 = resource.version30;

      const { resource: newResource, filesRoutes } = await ResourcesService.createResource({
        resourceData,
        files,
      });

      Object.keys(filesRoutes).forEach(async (fileType) => {
        const s3Url = filesRoutes[fileType];
        const file = resource[fileType];
        const start = performance.now();
        await axios.put(s3Url, file, {
          headers: { 'Content-Type': file.type },
        });
        let time = (performance.now() - start) / 1000;
        time = time.toFixed(2); // 2 decimals
        // eslint-disable-next-line no-console
        console.log('PUT time', time);
      });

      if (resource.type === 'scene') {
        const readFile = new FileReader();

        readFile.onload = function (e) {
          const contents = e.target.result;
          const sceneJson = JSON.parse(contents);
          dispatch(
            `relations/${CREATE_SCENE_DICT}`,
            { sceneJson, resourceId: newResource.id },
            { root: true }
          );
        };
        readFile.readAsText(resource.file);
      }

      commit(CREATE_RESOURCE, newResource);
      return newResource;
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
  async [UPDATE_RESOURCE]({ commit, dispatch }, resource) {
    try {
      const resourceData = {
        access: resource.access,
        name: resource.name,
        type: resource.type,
        scale: resource.scale || 1,
        status: resource.status,
        translations: resource.translations || null,
        resourceSize: resource.resourceSize || null,
      };
      const files = {
        fileName: (resource.file && resource.file.name) || {}.name,
        fileType: (resource.file && resource.file.type) || '',
      };

      switch (resource.type) {
        case 'character':
          resourceData.skeletonId = resource.skeletonId;
          resourceData.canWalk = resource.canWalk;
          break;
        case 'animation':
          resourceData.skeletonId = resource.skeletonId;
          resourceData.animationId = resource.animationId;
          break;
        case 'scene':
          resourceData.scene360 = resource.scene360;
          resourceData.walkable = resource.walkable;
          break;
      }
      resourceData.version30 = resource.version30;

      const { resource: updatedResource, filesRoutes } = await ResourcesService.updateResource({
        id: resource.id,
        resourceData,
        files,
      });

      if (resource.type === 'scene') {
        const readFile = new FileReader();

        readFile.onload = function (e) {
          const contents = e.target.result;
          const sceneJson = JSON.parse(contents);
          dispatch(
            `relations/${UPDATE_SCENE_DICT}`,
            { sceneJson, resourceId: resource.id },
            { root: true }
          );
        };
        readFile.readAsText(resource.file);
      }

      if (filesRoutes) {
        Object.keys(filesRoutes).forEach(async (fileType) => {
          const s3Url = filesRoutes[fileType];
          const file = resource[fileType];
          await axios.put(s3Url, file, {
            headers: { 'Content-Type': file.type },
          });
        });
      }
      commit(SET_RESOURCE, updatedResource);
      const resources = [...state.resources];
      const resourceIndex = state.resources.findIndex((r) => r.id === resource.id);
      if (resourceIndex > -1) {
        resources[resourceIndex] = updatedResource;
        commit(SET_RESOURCES, resources);
      }
      return updatedResource;
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
  async [CLEAR_RESOURCE]({ commit }) {
    commit(SET_RESOURCE, {});
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.error = error;
  },
  [SET_RESOURCES](state, resources) {
    state.resources = resources;
    state.error = null;
  },
  [SET_RESOURCES_DICT](state, dict) {
    state.resourcesDict = dict;
    state.error = null;
  },
  [SET_POSES_TYPES](state, poses) {
    state.posesTypes = poses;
    state.error = null;
  },
  [SET_SKELETONS_TYPES](state, skeletons) {
    console.log('SET_SKELETONS_TYPES - setting', skeletons.length, 'skeletons');
    state.skeletonsTypes = skeletons;
    state.error = null;
  },
  [SET_ANIMATIONS_TYPES](state, animations) {
    console.log('SET_ANIMATIONS_TYPES - setting', animations.length, 'animation types');
    state.animationsTypes = animations;
    state.error = null;
  },
  [SET_ANIMATIONS](state, animations) {
    state.animations = animations;
    state.error = null;
  },
  [SET_RESOURCE](state, resource) {
    if (!resource.access) {
      resource.access = {
        clientIds: [],
        mode: 'public',
      };
    }
    state.resource = resource;

    // Update resourcesDict if it exists and resource is published
    if (state.resourcesDict && resource.id && resource.status === 'PUBLISHED') {
      state.resourcesDict = {
        ...state.resourcesDict,
        [resource.id]: resource,
      };

      // Update animations array if the resource is an animation
      if (resource.type === 'animation') {
        const animationIndex = (state.animations || []).findIndex((a) => a.id === resource.id);
        if (animationIndex >= 0) {
          const updatedAnimations = [...state.animations];
          updatedAnimations[animationIndex] = resource;
          state.animations = updatedAnimations;
        } else {
          state.animations = [...(state.animations || []), resource];
        }
      }
    }

    state.error = null;
  },
  [DELETE_RESOURCE](state, id) {
    const index = state.resources.findIndex((item) => item.id === id);
    state.resources.splice(index, 1);

    // Update resourcesDict if it exists
    if (state.resourcesDict && state.resourcesDict[id]) {
      const { [id]: deleted, ...rest } = state.resourcesDict;
      state.resourcesDict = rest;

      // Update animations array if the deleted resource was an animation
      if (deleted.type === 'animation') {
        state.animations = (state.animations || []).filter((a) => a.id !== id);
      }
    }

    state.error = null;
  },
  [CREATE_RESOURCE](state, resource) {
    state.resources = [...state.resources, resource];

    // Update resourcesDict if it exists
    if (state.resourcesDict && resource.status === 'PUBLISHED') {
      state.resourcesDict = {
        ...state.resourcesDict,
        [resource.id]: resource,
      };

      // Update animations array if the resource is an animation
      if (resource.type === 'animation') {
        state.animations = [...(state.animations || []), resource];
      }
    }

    state.error = null;
  },
  [SET_RESOURCE_TYPE](state, { resource, type }) {
    switch (type) {
      case 'poses': {
        const poses = state.posesTypes;
        const index = poses.findIndex((current) => String(current.id) === String(resource.id));
        if (index >= 0) {
          state.posesTypes[index] = resource;
        } else {
          state.posesTypes = [...state.posesTypes, resource];
        }
        break;
      }
      case 'animations': {
        const animations = state.animationsTypes;
        const index = animations.findIndex((current) => String(current.id) === String(resource.id));
        if (index >= 0) {
          state.animationsTypes[index] = resource;
        } else {
          state.animationsTypes = [...state.animationsTypes, resource];
        }
        break;
      }
      case 'skeletons': {
        const skeletons = state.skeletonsTypes;
        const index = skeletons.findIndex((current) => String(current.id) === String(resource.id));
        if (index >= 0) {
          state.skeletonsTypes[index] = resource;
        } else {
          state.skeletonsTypes = [...state.skeletonsTypes, resource];
        }
        break;
      }
    }

    state.error = null;
  },
  [REMOVE_RESOURCE_TYPE](state, { type, id }) {
    switch (type) {
      case 'poses': {
        state.posesTypes = state.posesTypes.filter((pose) => String(pose.id) !== String(id));
        break;
      }
      case 'animations': {
        state.animationsTypes = state.animationsTypes.filter((animation) => String(animation.id) !== String(id));
        break;
      }
      case 'skeletons': {
        state.skeletonsTypes = state.skeletonsTypes.filter((skeleton) => String(skeleton.id) !== String(id));
        break;
      }
    }

    state.error = null;
  },
};

const getters = {
  getAnimationsBySkeletonId: (state) => (skeletonId) =>
    state.animations.filter((animation) => animation.skeletonId === skeletonId),
  isAnimationTypeInUse: (state) => (animationTypeId) =>
    (state.animations || []).some((animation) => String(animation.animationId) === String(animationTypeId)),
  isSkeletonTypeInUse: (state) => (skeletonTypeId) =>
    Object.values(state.resourcesDict || {}).some((resource) => resource.type === 'character' && String(resource.skeletonId) === String(skeletonTypeId)),
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
